/******************************************************************************************
 *	Login Controller
 *******************************************************************************************
 *
 * Checks IMS signed-in status from IMS Lib and based on that, either logs user in or
 * triggers SUSI login flow
 *
 */
(function() {
  angular.module('rcControllers.login', []).controller(
    'LoginController',
    /* @ngInject */
    function(_, $log, appReady, Auth, authentication, Redirector, User) {
      //If redirect was triggered, signInFlowTriggered is true
      var signInFlowTriggered = false;

      function requiresLogin() {
        signInFlowTriggered = true;

        authentication.signIn();
      }

      //Don't trigger sign in flow if:
      // - already triggered (e.g. waiting for browser to redirect to SUSI)
      // - auth is pending
      // - user is already logged in
      if (!signInFlowTriggered && !Auth.inProgress() && !Auth.isLoggedIn()) {
        //Check session status:
        // - if the user is logged in, get token and user profile. Setting the token on the Auth service will trigger AUTH_EVENTS.DONE.
        //   Aditionally, if an invitation exists, claim it for the currently logged in user.
        // - if the user is not logged in, trigger login flow.
        appReady.promise
          .then(() => {
            if (authentication.isUserSignedIn()) {
              const accessToken = authentication.getAccessToken();
              const userProfile = authentication.getUserProfile();

              //Set user profile
              User.set(
                userProfile.userId,
                userProfile.first_name,
                userProfile.last_name,
                userProfile.email
              );

              //Finally, authorize user
              Auth.login(accessToken);
            } else {
              requiresLogin();
            }
          })
          .catch(requiresLogin);
      }
    }
  );
})();
